/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentError = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V13h-2V9h-5V4H6v16h7v2H4zm11 3.414V7h1.586zm2.243 13.243-2.122-2.121 1.414-1.415 2.122 2.122 2.121-2.122 1.414 1.414-2.12 2.122 2.12 2.121-1.414 1.414-2.121-2.12-2.121 2.12-1.415-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentError as DocumentError };
